import React, { useRef, useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import images from "./BrandsData/BrandImages";

function Brands() {
  const sliderRef = useRef(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    const slider = sliderRef.current;
    const interval = setInterval(() => {
      slider.slickNext();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const handleWheel = (e) => {
      const slider = sliderRef.current;
      if (slider) {
        const delta = Math.sign(e.deltaY);
        if (delta > 0) {
          slider.slickNext();
        } else if (delta < 0) {
          slider.slickPrev();
        }
      }
    };

    const sliderElement = sliderRef.current?.innerSlider?.list;
    sliderElement?.addEventListener("wheel", handleWheel);

    return () => {
      sliderElement?.removeEventListener("wheel", handleWheel);
    };
  }, []);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 6, // Number of images displayed at a time
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 5000,
    cssEase: "linear",
  };

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  return (
    <div className="w-screen py-3 rounded-xl md:py-16 mt-20 bg-blueColor h-auto flex flex-col justify-center items-center">
      <div className="md:h-36 h-20 py-4 rounded-xl md:py-8 bg-white w-11/12 mx-auto flex flex-col justify-center shadow-md">
        <Slider
          ref={sliderRef}
          {...settings}
          style={{ touchAction: "pan-y" }} // Allow vertical scrolling on touch devices
        >
          {images.map((image, index) => (
            <a
              href={`#link-${index + 1}`} // Set the desired link for each image
              key={index}
              className="rounded-xl flex justify-center items-center"
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              <img
                className={`md:h-24 h-16 mx-20 md:ml-10 w-36 object-contain ${
                  hoveredIndex === index ? "scale-105" : ""
                }`}
                src={image}
                alt={`Carousel Image ${index + 1}`}
              />
            </a>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Brands;
